import {useCallback, useContext} from 'react'
import {useSelector} from 'react-redux'
import {PagePropsContext} from 'context/pageProps'
import {
  getAccommodationPageHotelId,
  getMetaBrandHasRooms
} from 'modules/accommodation/selectors'
import {useSapi} from 'modules/sapiSearch/SapiProvider'
import {getPreheatRoomsParams} from 'modules/searchApi/selectors'
import {PageProps as AccommodationPageProps} from 'pages/Hotel/[hotelSlug]/[locale]'
import {getPreheatParamsMismatchKeys} from 'utils/getPreheatParamsMismatchKeys'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

export const usePreheatRooms = () => {
  const {sapiClient} = useSapi()
  const toggle = useToggle()
  const hotelId = useSelector(getAccommodationPageHotelId)
  const preheatedRoomsParams = useSelector(state =>
    getPreheatRoomsParams(state, hotelId)
  )
  const brandHasRooms = useSelector(getMetaBrandHasRooms)
  const {serverPreheatRoomsParams} = (useContext(PagePropsContext) ??
    {}) as AccommodationPageProps

  const triggerRoomsPreheat = useCallback(() => {
    // Skip prefetching for Search Whitelabels (brands that don't support rooms)
    if (!brandHasRooms) {
      return
    }

    // On B the server already sent this exact preheat, so a second one adds nothing
    const hasServerPreheated =
      serverPreheatRoomsParams &&
      toggle('feature-ssr-rooms-preheat', false, true)
    if (
      hasServerPreheated &&
      !getPreheatParamsMismatchKeys(
        serverPreheatRoomsParams,
        preheatedRoomsParams
      ).length
    ) {
      return
    }

    sapiClient.rooms({
      ...preheatedRoomsParams,
      preHeat: 1
    })
  }, [
    preheatedRoomsParams,
    sapiClient,
    brandHasRooms,
    serverPreheatRoomsParams,
    toggle
  ])

  return {triggerRoomsPreheat}
}
